export default __webpack_public_path__ + "static/media/michael-jackson-silhouette.2c50fe2f.svg";